const formatBytes = (bytes, decimals = 2) => {
  if (!bytes || isNaN(bytes) || +bytes === 0) return 'N/A';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const formatOverviewDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

export const getDatasetOverviewItems = (dataset) => {
  if (!dataset) return [];

  const isBQ = dataset.source === 'bigquery';
  const stats = dataset.stats || {};
  const numRows = stats.num_rows ?? dataset.statistics?.num_rows;
  const numBytes = stats.num_bytes ?? dataset.statistics?.num_bytes;
  const columnCount = Array.isArray(dataset.schema)
    ? dataset.schema.length
    : dataset.column_count;

  return [
    {
      label: 'Source',
      value: isBQ ? 'BigQuery' : (dataset.source === 'upload' ? 'Manteo cloud' : dataset.source || 'N/A'),
    },
    ...(isBQ ? [
      { label: 'Project', value: stats.project || 'N/A' },
      { label: 'Dataset', value: stats.dataset || 'N/A' },
    ] : []),
    { label: 'Added', value: formatOverviewDate(dataset.created_at) },
    {
      label: 'Columns',
      value: columnCount !== undefined && columnCount !== null
        ? Number(columnCount).toLocaleString()
        : 'N/A',
    },
    {
      label: 'Rows',
      value: numRows !== undefined && numRows !== null
        ? Number(numRows).toLocaleString()
        : (dataset.rows ? Number(dataset.rows).toLocaleString() : 'N/A'),
    },
    {
      label: 'Size',
      value: numBytes !== undefined && numBytes !== null
        ? formatBytes(numBytes)
        : (dataset.size || 'N/A'),
    },
  ];
};

export const OVERVIEW_CHIP_CLASS =
  'inline-flex min-w-0 items-baseline gap-1.5 rounded-xl border border-gray-200 bg-white px-3 py-1.5 shadow-sm dark:border-gray-800 dark:bg-gray-950';

export const OVERVIEW_CHIP_LABEL_CLASS =
  'shrink-0 text-[9px] font-black uppercase tracking-wider text-gray-400';

export const OVERVIEW_CHIP_VALUE_CLASS =
  'truncate text-[11px] font-bold text-gray-800 dark:text-gray-100';
